/**
 * Fetch world-cities JSON from DataHub without credentials.
 * Must NOT go through fetchBaseQuery({ credentials: 'include' }) —
 * DataHub returns Access-Control-Allow-Origin: *, which browsers reject
 * for credentialed cross-origin requests (empty country list on signup).
 */
const WORLD_CITIES_URL =
  "https://pkgstore.datahub.io/core/world-cities/world-cities_json/data/5b3dd46ad10990bca47b04b4739a02ba/world-cities_json.json";

export async function fetchWorldCitiesQueryFn() {
  try {
    const response = await fetch(WORLD_CITIES_URL, {
      method: "GET",
      credentials: "omit",
      mode: "cors",
    });
    if (!response.ok) {
      return {
        error: {
          status: response.status,
          data: "Failed to load world cities",
        },
      };
    }
    const data = await response.json();
    return { data: Array.isArray(data) ? data : [] };
  } catch (error) {
    return {
      error: {
        status: "FETCH_ERROR",
        error: error?.message || "Failed to load world cities",
      },
    };
  }
}

export { WORLD_CITIES_URL };
